<template>
  <div class="flex flex-wrap justify-between items-baseline my-2">
    <div class="w-full sm:w-4/5">
      <div class="input-group sm:mr-8">
        <input
          v-model="queryString.search"
          type="text"
          :placeholder="placeholder"
        >
        <button
          class="btn btn-sm"
          type="submit"
          v-text="'Search'"
        />
      </div>
    </div>
    <div class="w-full sm:w-1/5">
      <div class="select-container">
        <select v-model="queryString.filter">
          <option
            v-for="option in filterOptions"
            :key="option"
            :value="option.toLowerCase()"
            v-text="option"
          />
        </select>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'EmailDeliveryFilter',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({
        search: '',
        filter: 'all',
      }),
    },
    filterOptions: {
      type: Array,
      required: false,
      default: () => [
        'All',
        'Queued',
        'Delivered',
        'Opened',
        'Failed',
      ],
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Search Deliveries',
    },
  },
  computed: {
    queryString: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit(value)
      },
    },
  },
}
</script>